// extracted by mini-css-extract-plugin
export var container = "_e6-0";
export var icon = "_e6-1";
export var text = "_e6-2";